import React, { createContext, ReactNode, useContext, useMemo, useState } from "react";

const ScrollPositionContext = createContext<{}>({});

export default ScrollPositionContext;

export function ProvideScrollPosition({ children }: { children: ReactNode }) {
    const [position, setPosition] = useState(0);
    const [initialLoad, setInitialLoad] = useState(false);
    const [prevItemId, setPrevItemId] = useState();
    const value = useMemo(
        () => ({ position, setPosition, initialLoad, setInitialLoad, prevItemId, setPrevItemId }),
        [position, initialLoad, prevItemId],
    );
    return (
        <ScrollPositionContext.Provider value={value}>
            {children}
        </ScrollPositionContext.Provider>
    );
}

export const useScrollPosition = () => useContext(ScrollPositionContext);
